
export const VEHICLE_MODEL = {
  TRANSIT: 'TRANSIT'
};
